import { contest } from './initializeStats';
import { statsArticle } from './statsArticle';
import { inViewport } from './elementsInViewport';
import { linkStats, setStatElementCollector, shareStats } from './stats';
import { anchors } from './anchors';
import { counter } from './counter';
import { validateAndSubmitForm } from './form';
import { countingCharacters } from './countingCharacters';
import { checkItemsCountForGridType } from './helpers';

// const debounce = (func, delay = 1000) => {
//   let timeoutId;
//   return (...args) => {
//     if (timeoutId) {
//       clearTimeout(timeoutId);
//     }
//     timeoutId = setTimeout(() => {
//       func(...args);
//     }, delay);
//   };
// };

anchors();
statsArticle();
setStatElementCollector();
linkStats();
inViewport();
shareStats();
counter();
validateAndSubmitForm();

checkItemsCountForGridType('.section-card');

document.querySelectorAll('textarea').forEach((input) => {
  countingCharacters(input);
});

window.addEventListener('beforeunload', contest.unloadData.bind(contest));

// for testing
// document.querySelector('.header').addEventListener('click', contest.unloadData.bind(contest));
